(function ()
{
	var googleSearchName = "search";
	var searchInputSelector = ".search";
	var getSearch = function ()
	{
		try
		{
			return google.search.cse.element.getElement(googleSearchName);
		}
		catch (_)
		{
			return null;
		}
	};

	var setQuery = function (queryParam, query)
	{
		if
		(
			history.pushState === undefined ||
			window.URLSearchParams === undefined
		)
			return;

		var params = new URLSearchParams(location.search);
		params.set(queryParam, query);

		var url = location.pathname +
			"?" + params.toString() +
			location.hash;

		history.pushState(null, "", url);
	};

	$(document)
		.on("input", searchInputSelector, function ()
		{
			$(searchInputSelector).val($(this).val());
		})
		.on("submit", "form:has(" + searchInputSelector + ")", function (event)
		{
			var search = getSearch();

			if (search === null)
				return;

			event.preventDefault();

			var $searchInput = $(this).find(searchInputSelector);
			var queryParam = $searchInput.attr("name");
			var query = $searchInput.val();

			setQuery(queryParam, query);
			search.execute(query);
		});
	
	$(window).on("popstate", function ()
	{
		if (window.URLSearchParams === undefined)
			return;

		var search = getSearch();

		if (search === null)
			return;

		var $searchInputs = $(searchInputSelector);
		var queryParam = $searchInputs.attr("name");
		var params = new URLSearchParams(location.search);

		if (!params.has(queryParam))
			return;

		var query = params.get(queryParam);
		$searchInputs.val(query);
		search.execute(query);
	});
})();
